import { call, put, select, takeLatest } from 'redux-saga/effects';

import { chatDrawerState } from 'modules/common/chat/data/actions';
import {
  CHANNEL_TYPES,
  CHAT_DRAWER_STATE,
} from 'modules/common/chat/data/constants';
import { getActiveChannelType } from 'modules/common/chat/data/reducer';
import {
  getFirstSecondaryChannelId,
  getMSCChatChannelId,
  getPennChannelId,
  getInternalTeamChatChannelId,
} from 'modules/common/chat/entities/reducer';
import { types as viewerPageTypes } from 'modules/viewerPage/data/actions';
import { APPS_PANEL_STATES } from 'modules/viewerPage/data/constants';
import { doesUserOwnPart } from 'modules/viewerPage/data/reducer';
import { initializeFastenerAvailabilityApp } from 'modules/viewerPage/penn/fastenerAvailability/data/sagas';

export default function* root() {
  yield takeLatest(
    viewerPageTypes.SET_APPS_PANEL_STATE,
    watchChangeSideBarState,
  );
}

function* watchChangeSideBarState(action) {
  try {
    const { appsPanelState } = action.payload;
    switch (appsPanelState) {
      case APPS_PANEL_STATES.MSC_CHAT: {
        // initialize the MSC chat
        const mscChannelId = yield select(getMSCChatChannelId);
        yield put(
          chatDrawerState.set({
            activeChannelId: mscChannelId,
            activeChannelType: CHANNEL_TYPES.MSC,
          }),
        );
        break;
      }
      case APPS_PANEL_STATES.VIEWER_CHAT: {
        // initialize standard channel
        const isOwner = yield select(doesUserOwnPart);
        const activeChannelType = yield select(getActiveChannelType);
        if (isOwner) {
          if (activeChannelType !== CHANNEL_TYPES.PRIMARY) {
            const internalChannelId = yield select(
              getInternalTeamChatChannelId,
            );
            yield put(
              chatDrawerState.set({
                activeChannelId: internalChannelId,
                activeChannelType: CHANNEL_TYPES.PRIMARY,
                chatDrawerState: CHAT_DRAWER_STATE.TEAM,
              }),
            );
          }
        } else {
          if (activeChannelType !== CHANNEL_TYPES.SECONDARY) {
            const seconaryChannelId = yield select(getFirstSecondaryChannelId);
            yield put(
              chatDrawerState.set({
                activeChannelId: seconaryChannelId,
                activeChannelType: seconaryChannelId
                  ? CHANNEL_TYPES.SECONDARY
                  : null,
                chatDrawerState: CHAT_DRAWER_STATE.EXTERNAL,
              }),
            );
          }
        }
        break;
      }
      case APPS_PANEL_STATES.PENN_CHAT: {
        // initialize PENN chat
        const pennChannelId = yield select(getPennChannelId);
        yield put(
          chatDrawerState.set({
            activeChannelId: pennChannelId,
            activeChannelType: CHANNEL_TYPES.PENN,
          }),
        );
        break;
      }
      case APPS_PANEL_STATES.PENN_AVAILABILITY_WIDGET:
        yield call(initializeFastenerAvailabilityApp);
        break;
      default:
        break;
    }
  } catch (error) {
    console.error('Error in watchChangeSideBarState', error);
  }
}
